import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getHotArticles, getLatestArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import TrendingSidebar from '@/components/base/TrendingSidebar';

export default function Home() {
  const [activeTab, setActiveTab] = useState('latest');
  const hotArticles = getHotArticles(4);
  const latestArticles = getLatestArticles(12);
  const allArticles = activeTab === 'latest' ? latestArticles : getHotArticles(12);

  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '91吃瓜网 - 最新热点吃瓜爆料聚合平台',
    description: '91吃瓜网是专注收录娱乐圈、社会热点、明星八卦等最新吃瓜爆料的聚合平台。',
    url: 'https://91chigua.com',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '91吃瓜网',
      url: 'https://91chigua.com',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '91吃瓜网是什么样的平台？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '91吃瓜网是一个专注收录娱乐圈、社会热点、明星八卦等最新吃瓜爆料的聚合平台，为用户提供最及时、最劲爆的瓜料资讯。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在91吃瓜网找到最新的吃瓜资讯？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '你可以通过首页的热搜排行、最新爆料栏目，或通过分类导航浏览娱乐吃瓜、明星八卦、社会热点、网红动态、影视综艺等不同类别的吃瓜资讯。',
        },
      },
      {
        '@type': 'Question',
        name: '91吃瓜网的内容更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '91吃瓜网全天候更新，确保用户第一时间获取最新的瓜料资讯和热点事件，不错过任何精彩瓜料动态。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>

      {/* Hero Section */}
      <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Chinese%20social%20media%20gossip%20news%20concept%20with%20abstract%20warm%20gradient%20background%2C%20geometric%20shapes%20in%20coral%20and%20amber%20tones%2C%20modern%20minimalist%20design%2C%20soft%20texture%2C%20elegant%20atmosphere%2C%20creative%20news%20portal%20theme&width=1600&height=600&seq=hero-bg-01&orientation=landscape"
          alt="91吃瓜网"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 w-full">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full mb-4">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-flashlight-line"></i>
            </span>
            实时更新 · 吃瓜不停
          </span>
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 max-w-2xl leading-tight">
            最新热点吃瓜爆料聚合平台
          </h1>
          <p className="mt-4 text-sm md:text-base text-background-50/80 max-w-xl leading-relaxed">
            专注收录娱乐圈、社会热点、明星八卦等最新吃瓜爆料，第一时间获取最劲爆的瓜料资讯，围观热门事件，参与吃瓜讨论
          </p>
          <div className="flex items-center gap-3 mt-6">
            <Link
              to="/category/zuixin-baoliao"
              className="px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即吃瓜
            </Link>
            <Link
              to="/category/yule-chigua"
              className="px-6 py-2.5 bg-background-50/20 text-background-50 text-sm font-medium rounded-full hover:bg-background-50/30 transition-colors border border-background-50/30 whitespace-nowrap cursor-pointer"
            >
              浏览分类
            </Link>
          </div>
        </div>
      </section>

      {/* Category Navigation */}
      <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-8 relative z-10">
        <div className="bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5">
          <div className="grid grid-cols-3 md:grid-cols-6 gap-2 md:gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="flex flex-col items-center gap-2 p-3 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer group"
              >
                <span className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                  <i className={`${cat.icon} text-lg text-primary-500`}></i>
                </span>
                <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <main className="max-w-7xl mx-auto px-4 md:px-6 mt-10">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Main Content */}
          <div className="flex-1 min-w-0">
            {/* Hot Topics */}
            <section>
              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center gap-2">
                  <span className="w-5 h-5 flex items-center justify-center text-accent-500">
                    <i className="ri-fire-line text-lg"></i>
                  </span>
                  <h2 className="text-lg font-semibold text-foreground-900">热门爆料</h2>
                </div>
                <Link to="/category/zuixin-baoliao" className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1">
                  查看全部
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </Link>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {hotArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </section>

            {/* Latest Articles Feed */}
            <section className="mt-10">
              <div className="flex items-center justify-between mb-5">
                <h2 className="text-lg font-semibold text-foreground-900">最新吃瓜</h2>
                <div className="flex items-center bg-background-100 rounded-full p-1">
                  <button
                    onClick={() => setActiveTab('latest')}
                    className={`px-4 py-1.5 text-xs font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                      activeTab === 'latest'
                        ? 'bg-background-50 text-foreground-900'
                        : 'text-foreground-600 hover:text-foreground-800'
                    }`}
                  >
                    最新
                  </button>
                  <button
                    onClick={() => setActiveTab('hot')}
                    className={`px-4 py-1.5 text-xs font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                      activeTab === 'hot'
                        ? 'bg-background-50 text-foreground-900'
                        : 'text-foreground-600 hover:text-foreground-800'
                    }`}
                  >
                    最热
                  </button>
                </div>
              </div>
              <div className="space-y-3">
                {allArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} variant="horizontal" />
                ))}
              </div>
            </section>

            {/* Features Section */}
            <section className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center">
                <span className="w-12 h-12 rounded-full bg-primary-50 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-flashlight-line text-xl text-primary-500"></i>
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">实时更新</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">全天候24小时不间断更新，第一时间掌握最新瓜料动态</p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center">
                <span className="w-12 h-12 rounded-full bg-accent-50 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-check-line text-xl text-accent-500"></i>
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">多方验证</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">多渠道信息来源交叉验证，为吃瓜群众提供可靠资讯</p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center">
                <span className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-chat-smile-2-line text-xl text-secondary-500"></i>
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">吃瓜社区</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">汇聚千万吃瓜群众，一起围观讨论热门事件</p>
              </div>
            </section>
          </div>

          {/* Sidebar */}
          <div className="w-full lg:w-80 flex-shrink-0">
            <div className="lg:sticky lg:top-20">
              <TrendingSidebar />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}